import { css } from 'aphrodite';
import * as React from 'react';
import { FieldError } from 'react-hook-form';
import { styleSheet } from '../styles';

interface ErrorMessageProps {
	message?: string | FieldError | any;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => {
	if (!message) return null;

	// Handle FieldError type
	const errorText = typeof message === 'string' ? message : message?.message || '';

	if (!errorText) return null;

	return <span className={css(styleSheet.errorMessage)}>{errorText}</span>;
};
